import { useDispatch, useSelector } from 'react-redux';
import { getTextProcessStatus, inspection, getInspectionSettings } from 'store';
import GVCheckbox from 'components/lib/GVCheckbox/GVCheckbox';
import BrailleLanguageSelect from 'components/BrailleLanguageSelect';
import { useEffect, useState } from 'react';

const BrailleSettings = () => {
  const dispatch = useDispatch();
  const documentProcessed = useSelector(getTextProcessStatus);
  const inspectionSettings = useSelector(getInspectionSettings);
  const [brailleChecked, setBrailleChecked] = useState(inspectionSettings.brailleLanguage !== undefined);

  useEffect(() => {
    setBrailleChecked(!!inspectionSettings.brailleLanguage);
  }, [inspectionSettings.brailleLanguage]);

  const toggleBrailleCheck = (value: boolean) => {
    value
      ? dispatch(inspection.actions.setInspectionSettings({ brailleLanguage: 'English' }))
      : dispatch(inspection.actions.setInspectionSettings({ brailleLanguage: '' }));
    setBrailleChecked(value);
  };

  return (
    <>
      <GVCheckbox
        checked={brailleChecked}
        onChange={() => toggleBrailleCheck(!brailleChecked)}
        label="Braille"
        data-testid="brailleinspection_enable"
        disabled={!documentProcessed}
      />
      {brailleChecked && <BrailleLanguageSelect />}
    </>
  );
};

export default BrailleSettings;
